/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

